module.exports = __webpack_public_path__ + "media/images/sanfran_02_wide-042aaace949f6eee97966ceeeadef419.jpg";